import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from './ui/button';
import { ArrowRight, Menu, X } from 'lucide-react';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80; // Height of navbar
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
    setMobileMenuOpen(false);
  };

  const navLinks = [
    { name: 'SERVIZI', id: 'servizi' },
    { name: 'CHI SIAMO', id: 'chi-siamo' },
    { name: 'CASE STUDIES', id: 'case-studies' },
    { name: 'CONTATTI', id: 'contatti' }
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-black/80 backdrop-blur-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1600px] mx-auto px-4 lg:px-6">
        <div className="flex items-center justify-between h-20">
          {/* Logo - Left */}
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="text-white text-lg font-semibold tracking-[0.2em] hover:opacity-80 transition-opacity"
            style={{ fontFamily: 'Inter, system-ui, sans-serif', letterSpacing: '0.2em' }}
          >
            SL MANAGEMENT
          </button>

          {/* Desktop Navigation - Center */}
          <div className="hidden md:flex items-center absolute left-1/2 transform -translate-x-1/2 gap-x-[75px]">
            {navLinks.map((link) => (
              <button
                key={link.id}
                onClick={() => scrollToSection(link.id)}
                className="text-xs font-medium text-gray-400 hover:text-white transition-colors duration-200 tracking-wider whitespace-nowrap"
              >
                {link.name}
              </button>
            ))}
          </div>

          {/* CTA Button - Right */}
          <div className="hidden md:block">
            <Button
              onClick={() => scrollToSection('contatti')}
              className="bg-white/10 hover:bg-white/20 text-white border border-white/20 rounded-full px-6 transition-all duration-300 text-sm"
            >
              Parlaci del tuo Progetto
              <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-white"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-black/95 backdrop-blur-lg border-t border-white/10">
          <div className="px-6 py-6 space-y-4">
            {navLinks.map((link) => (
              <button
                key={link.id}
                onClick={() => scrollToSection(link.id)}
                className="block w-full text-left text-gray-300 hover:text-white transition-colors"
              >
                {link.name}
              </button>
            ))}
            <Button
              onClick={() => scrollToSection('contatti')}
              className="w-full bg-white/10 hover:bg-white/20 text-white border border-white/20 rounded-full"
            >
              Parlaci del tuo Progetto
              <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;